import { CameraIcon, css, styled } from 'canoe';
import React from 'react';

const NoSnapshotThumbnailWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.spaces.xxs};
    width: 100%;
    height: 155px;
    font-size: ${theme.fonts.small.fontSize};
    color: ${theme.colors.GlitterGrayD10};
    background-color: ${theme.colors.OnyxGrayL20};
    border: 1px solid ${theme.colors.OnyxGrayL20};
    border-radius: ${theme.borderRadius.small};
  `}
`;

export const NoSnapshotThumbnail = () => (
  <NoSnapshotThumbnailWrapper>
    <CameraIcon color="GlitterGrayD10" />
    <span>No Snapshot</span>
  </NoSnapshotThumbnailWrapper>
);
